import React from "react";

import { createCtx } from "@phoenix/context/context";

export interface InspectorStore {
  showInspector: boolean;
}

export const [useInspectorContext, InspectorContextProvider] = createCtx<InspectorStore | undefined>();
const InspectorActionsContext = React.createContext<(inspectorStore: Partial<InspectorStore>) => void>(() => {});
export const useInspectorActionsContext = (): ((inspectorStore: Partial<InspectorStore>) => void) => {
  const context = React.useContext(InspectorActionsContext);
  if (context === undefined) {
    throw new Error(`Context must be called within Provider`);
  }
  return context;
};

type Props = { children: React.ReactNode };

export const InspectorProvider = ({ children }: Props): React.ReactElement => {
  const [inspectorStore, setInspectorStore] = React.useState<InspectorStore>({
    showInspector: true,
  });

  return (
    <InspectorContextProvider value={inspectorStore}>
      <InspectorActionsContext.Provider
        value={(store: Partial<InspectorStore>) =>
          setInspectorStore((prev: $TSFixMe) => ({
            ...prev,
            ...store,
          }))
        }
      >
        {children}
      </InspectorActionsContext.Provider>
    </InspectorContextProvider>
  );
};
